// extracted by css-extract-rspack-plugin
export default {"radioCheckboxGroupContainer":"OrganisationTypeForm_radioCheckboxGroupContainer__Pe40D","errorContainer":"OrganisationTypeForm_errorContainer__Gyq3D"};